module.exports = new __parcel__URL__("hubHeader.8036253d.svg").toString();